// FooterSection.js 
 import React from 'react';
  import { Container, Row, Col, Form, Button } from 'react-bootstrap'; 
  import './EndofWeb.css';
import mapi from "../assets/Images/mapi.jpg"

const FooterSection = () => {
  return (
    <div className="footer-wrapper">
      
     {/* Google Map Section */}
<div className="footer-map">
 <img
 src={mapi}
 alt='footer visual'
 style={{width:'100%',height:"300px",objectFit:"cover",border:"none" }}
 
 />
</div>

      {/* Footer Columns */}
      <div className="footer-columns">
        <Container>
          <Row className="footer-row">
            
            <Col md={3} sm={6} className="footer-col">
              <h5>USEFUL LINKS</h5>
              <ul>
                <li>About Us</li>
                <li>Company Profile</li>
                <li>Green Cleaning</li>
                <li>Our Material</li>
                <li>Catalog</li>
              </ul>
            </Col>

            <Col md={3} sm={6} className="footer-col">
              <h5>PRODUCTS</h5>
              <ul>
                <li>Mops</li>
                <li>Eagle cleaning cloths</li>
                <li>Handles</li>
                <li>Frames and Holders</li>
                <li>Miscellaneous</li>
                <li>Trolleys & Wringers</li>
              </ul>
            </Col>

            <Col md={3} sm={6} className="footer-col">
              <h5>STAY UPDATED</h5>
              <p>Get the latest about Eagle products & more</p>
              <Form className="subscribe-form">
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  className="footer-input"
                />
                <Button variant="danger" className="subscribe-btn">
                  SUBSCRIBE
                </Button>
              </Form>
            </Col>

            <Col md={3} sm={6} className="footer-col">
              <h5>HAPPY CLIENTS</h5>
              <p>
                I am a client of Eagle for years & completely trust their
                products. Choosing Eagle Cleaning products is a wise decision.
                Quality is high and the results are always best in use.
              </p>
              <Button variant="outline-danger" className="more-btn">
                MORE VIEW
              </Button>
              <p className="client-name">MARK KANE</p>
            </Col>

          </Row>
        </Container>
      </div>

      {/* Footer Bottom Line */}
      <div className="footer-bottom text-center py-2">
        <p className="mb-0">
          © 2020 Eagle. All rights reserved. <br />
          Design & Developed by <span className="dev-name">RB DEVELOPERS</span>
        </p>
      </div>
    </div>
  );
};



export default FooterSection;